'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends2 = require('babel-runtime/helpers/extends');

var _extends3 = _interopRequireDefault(_extends2);

var _classCallCheck2 = require('babel-runtime/helpers/classCallCheck');

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = require('babel-runtime/helpers/createClass');

var _createClass3 = _interopRequireDefault(_createClass2);

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _reactDom = require('react-dom');

var _reactDom2 = _interopRequireDefault(_reactDom);

var _Product = require('../react/Product.jsx');

var _Product2 = _interopRequireDefault(_Product);

var _axios = require('axios');

var _axios2 = _interopRequireDefault(_axios);

var _AsyncView = require('../components/AsyncView');

var _AsyncView2 = _interopRequireDefault(_AsyncView);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var StaticProductReact = function () {
  function StaticProductReact(section) {
    (0, _classCallCheck3.default)(this, StaticProductReact);

    this.context = JSON.parse(document.querySelector('[data-product-context]').innerHTML);
    this.root = section.el.querySelector('[data-section-root]');
    this.pbc = document.querySelector('.page-body-content');
    this.loadProduct = this.loadProduct.bind(this);
    this.renderProduct = this.renderProduct.bind(this);
    this.url = new URL(window.location);
    var variantId = this.url.searchParams.get('variant');
    var defaultVariant = null;

    if (variantId) {
      variantId = parseInt(variantId, 10);
      defaultVariant = section.data.product.variants.find(function (v) {
        return v.id === variantId;
      });
    } else if (section.data.product.variants.length === 1) {
      defaultVariant = section.data.product.variants[0];
    }

    this.renderProduct(section.data, defaultVariant);
  }

  (0, _createClass3.default)(StaticProductReact, [{
    key: 'loadProduct',
    value: function loadProduct(product, prevVariant) {
      var _this = this;

      this.pbc.classList.add('loading');
      var productData = _AsyncView2.default.load('/products/' + product.handle, 'json').then(function (response) {
        var temp = document.createElement('div');
        temp.innerHTML = response.html;
        var productData = JSON.parse(temp.querySelector('[data-section-data]').innerHTML);
        _this.url.pathname = '/products/' + productData.product.handle;
        var defaultVariant = null;
        if (prevVariant) {
          var variantTitle = prevVariant.title.replace(/standard\s*\/\s*/i, '');
          defaultVariant = productData.product.variants.find(function (v) {
            return variantTitle === v.title.replace(/standard\s*\/\s*/i, '');
          });
          defaultVariant && _this.url.searchParams.set('variant', defaultVariant.id);
        }
        window.history.replaceState(productData, productData.product.title, _this.url.href);
        _this.renderProduct(productData, defaultVariant);
        _this.pbc.classList.remove('loading');
        document.querySelector('title').innerHTML = response.options.page_title;
        document.querySelector('link[rel="canonical"]').href = response.options.canonical_url;

        var curVariant = defaultVariant || productData.product.variants[0];

        window.dispatchEvent(new CustomEvent('localizeContent'));

        if (typeof ga === 'function') {
          ga('set', { "page": location.pathname, "title": document.title });
          ga('send', 'pageview');
          ga('send', 'event', 'Product', 'Viewed Product', { nonInteraction: true });

          ga('send', 'event', productData.product.type, 'Viewed Product', { nonInteraction: true });
          dataLayer.push({ 'event': 'optimize.activate' });

          ga('ec:addProduct', {
            'id': curVariant.id,
            'name': curVariant.name,
            'category': productData.product.type,
            'brand': productData.product.vendor
          });
          ga('ec:setAction', 'detail');
        }

        if (typeof fbq === 'function') {
          fbq('track', 'ViewContent', {
            content_name: curVariant.name,
            content_category: productData.product.type,
            content_ids: [productData.product.id],
            content_type: 'product_group',
            value: curVariant.price / 100,
            currency: 'USD'
          });
        }
      });

      var promisesArray = [];
      promisesArray.push(productData);

      if (document.querySelector('#shopify-section-static-exit-intent')) {
        var exitPopup = _axios2.default.get('/products/' + product.handle + '?section_id=static-exit-intent').then(function (response) {
          document.querySelector('#shopify-section-static-exit-intent').innerHTML = response.data;
        });
        promisesArray.push(exitPopup);
      }

      var productFeatures = _axios2.default.get('/products/' + product.handle + '?section_id=product-features').then(function (response) {
        document.querySelector('#shopify-section-product-features').innerHTML = response.data;
      });
      promisesArray.push(productFeatures);

      Promise.all(promisesArray).then(function () {
        document.dispatchEvent(new CustomEvent("product-change"));
      });
    }
  }, {
    key: 'renderProduct',
    value: function renderProduct(productData, defaultVariant) {
      var productOptionsWithValues = [];
      delete productData.product.content;
      delete productData.product.created_at;
      delete productData.product.images;
      delete productData.product.published_at;

      productData.product.options.forEach(function (option) {
        productOptionsWithValues.push({ name: option, values: [] });
      });

      productData.product.variants.forEach(function (variant) {
        variant.options.forEach(function (option, i) {
          if (!productOptionsWithValues[i].values.includes(option)) {
            productOptionsWithValues[i].values.push(option);
          }
        });
      });

      productData.product.options_with_values = productOptionsWithValues;
      _reactDom2.default.unmountComponentAtNode(this.root);
      _reactDom2.default.render(_react2.default.createElement(_Product2.default, (0, _extends3.default)({}, productData, { defaultVariant: defaultVariant, url: this.url, onProductChange: this.loadProduct, context: this.context })), this.root);

      window.heap && window.heap.track('ProductView', { title: productData.product.title, vendor: productData.product.vendor, price: productData.product.price, handle: productData.product.handle });

      var monetateCSS = document.querySelector('style#mt-css');
      if (monetateCSS) {
        monetateCSS.remove();
      }

      window.monetateQ = window.monetateQ || [];
      window.monetateQ.push(["setPageType", "product"]);
      window.monetateQ.push(["addProductDetails", [productData.product.id]]);

      window.monetateQ.push(["trackData"]);
    }
  }, {
    key: 'onSectionUnload',
    value: function onSectionUnload() {
      _reactDom2.default.unmountComponentAtNode(this.root);
    }
  }]);
  return StaticProductReact;
}();

exports.default = StaticProductReact;